// src/constants/assessmentTypes.js

export const MATURITY_LEVELS = {
  ML1: 'ML1',
  ML2: 'ML2',
  ML3: 'ML3'
};

export const ANSWER_TYPES = {
  NOT_ASSESSED: 'not_assessed',
  EFFECTIVE: 'effective',
  ALTERNATE_CONTROL: 'alternate_control',
  INEFFECTIVE: 'ineffective',
  NO_VISIBILITY: 'no_visibility',
  NOT_IMPLEMENTED: 'not_implemented',
  NOT_APPLICABLE: 'not_applicable'
};

export const ANSWER_DESCRIPTIONS = {
  not_assessed: 'The control has not yet been assessed.',
  effective: 'The organisation is effectively meeting the control\'s objective.',
  alternate_control: 'The organisation is effectively meeting the control\'s objective through an alternate control.',
  ineffective: 'The organisation is not adequately meeting the control\'s objective.',
  no_visibility: 'The assessor was unable to obtain adequate visibility of a control\'s implementation.',
  not_implemented: 'The organisation has decided not to implement the control.',
  not_applicable: 'The control does not apply to the system or environment.'
};

export const CONTROL_TYPES = {
  PATCH_APPLICATIONS: 'Patch Applications',
  PATCH_OS: 'Patch Operating Systems',
  MFA: 'Multi-factor Authentication',
  ADMIN_PRIVILEGES: 'Restrict Administrative Privileges',
  APP_CONTROL: 'Application Control',
  OFFICE_MACROS: 'Configure Microsoft Office macro settings',
  APP_HARDENING: 'User Application Hardening',
  BACKUPS: 'Regular Backups'
};